import { QualityList } from '../../api/reportApi'

/** 暂存草稿的读侧规则：只有供应商填报的部分值得保留，主数据一律用实时值 */
export interface StorageDraft {
  formData?: Record<string, any>
  platform_formData?: Record<string, any>
  state?: { qualityDataList?: QualityList[] }
}

/** 主表单里唯一可编辑的三个销售审核字段，其余分区都被只读遮罩包着 */
export const SUPPLIER_FILLED_FORM_KEYS = [
  'saleJobNumber',
  'saleName',
  'saleRemark',
] as const

export interface SupplierFilledDraft {
  formValues: Record<string, any>
  platformFormValues: Record<string, any>
  qualityDataList?: QualityList[]
}

export const pickSupplierFilledDraft = (
  draft?: StorageDraft | null,
): SupplierFilledDraft | null => {
  if (!draft) {
    return null
  }
  const formData = draft.formData || {}
  const formValues: Record<string, any> = {}
  // 草稿里没有的键不回填：rc-field-form 是浅合并，undefined 会把实时值盖掉
  SUPPLIER_FILLED_FORM_KEYS.forEach((key) => {
    if (key in formData) {
      formValues[key] = formData[key]
    }
  })
  return {
    formValues,
    platformFormValues: draft.platform_formData || {},
    qualityDataList: draft.state?.qualityDataList,
  }
}
import { QualityList } from '../../api/reportApi'

/** 暂存草稿的读侧规则：只有供应商填报的部分值得保留，主数据一律用实时值 */
export interface StorageDraft {
  formData?: Record<string, any>
  platform_formData?: Record<string, any>
  state?: { qualityDataList?: QualityList[] }
}

/** 主表单里唯一可编辑的三个销售审核字段，其余分区都被只读遮罩包着 */
export const SUPPLIER_FILLED_FORM_KEYS = [
  'saleJobNumber',
  'saleName',
  'saleRemark',
] as const

export interface SupplierFilledDraft {
  formValues: Record<string, any>
  platformFormValues: Record<string, any>
  qualityDataList?: QualityList[]
}

export const pickSupplierFilledDraft = (
  draft?: StorageDraft | null,
): SupplierFilledDraft | null => {
  if (!draft) {
    return null
  }
  const formData = draft.formData || {}
  const formValues: Record<string, any> = {}
  // 草稿里没有的键不回填：rc-field-form 是浅合并，undefined 会把实时值盖掉
  SUPPLIER_FILLED_FORM_KEYS.forEach((key) => {
    if (key in formData) {
      formValues[key] = formData[key]
    }
  })
  return {
    formValues,
    platformFormValues: draft.platform_formData || {},
    qualityDataList: draft.state?.qualityDataList,
  }
}
